import { render } from "./StatistiquesPage.vue?vue&type=template&id=0b7f0626"
import script from "./StatistiquesPage.vue?vue&type=script&lang=js"
export * from "./StatistiquesPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__